<div>
  
  <!-- Action Toolbar Header Section -->
  <header class="d-flex align-items-center gap-2 mt-2 mb-2 p-3 rounded-4 border shadow-sm bg-body-tertiary">
    <button type="button" class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base" (click)="goBack()">
      <i class="fa-solid fa-arrow-left font-xs"></i>
      <span>Back</span>
    </button>
  </header>

  <!-- Premium Ledger Workspace Table Wrapper Box -->
  <div class="card border shadow-sm rounded-4 overflow-hidden bg-body w-100 mb-4">
    <!-- Integrated your pre-compiled high-density dashboard scroll framework layout wrapper -->
    <div class="table-responsive-container m-0">
      <table class="table table-hover align-middle mb-0 table-dense text-nowrap">
        
        <!-- High-Density Dynamic Head Structure Matrix Mapping -->
        <thead class="table-light text-body-secondary border-bottom font-monospace small text-uppercase tracking-wider">
          
          <!-- Case 1: BOP (Phone Bill Topup Layout) -->
          @if (type.includes('BOP')) {
            <tr>
              <th scope="col" class="ps-4 py-3" width="70">Sr No</th>
              <th scope="col" class="py-3" style="min-width: 140px;">Transaction ID</th>
              <th scope="col" class="py-3" style="min-width: 120px;">Payment Phone</th>
              <th scope="col" class="py-3" style="min-width: 130px;">Service Name</th>
              <th scope="col" class="py-3" style="min-width: 110px;">Result Code</th>
              <th scope="col" class="py-3" style="min-width: 220px;">Description</th>
              <th scope="col" class="pe-4 py-3 text-center" width="120">Status</th>
            </tr>
          }
          
          <!-- Case 2: BOW (Wallet Cash Transfers Layout - Wave/AYA) -->
          @if (type.includes('BOW')) {
            <tr>
              <th scope="col" class="ps-4 py-3" width="70">Sr No</th>
              <th scope="col" class="py-3" style="min-width: 130px;">Payment Phone</th>
              <th scope="col" class="py-3" style="min-width: 160px;">Payment Name</th>
              <th scope="col" class="pe-4 py-3" style="min-width: 320px;">Description Message</th>
            </tr>
          }
          
          <!-- Case 3: KBZ (KBZPay Integration Layout) -->
          @if (type.includes('KBZ')) {
            <tr>
              <th scope="col" class="ps-4 py-3" width="60">No</th>
              <th scope="col" class="py-3" style="min-width: 130px;">Payment Phone</th>
              <th scope="col" class="py-3" style="min-width: 150px;">Payment Name</th>
              <th scope="col" class="py-3 text-center" width="110">Response Code</th>
              <th scope="col" class="py-3" style="min-width: 100px;">Result</th>
              <th scope="col" class="py-3" width="90">Code</th>
              <th scope="col" class="py-3" width="120">Trade Status</th>
              <th scope="col" class="py-3" style="min-width: 180px;">Message</th>
              <th scope="col" class="py-3 text-end" width="120">Total Amount</th>
              <th scope="col" class="py-3 text-center" width="90">Currency</th>
              <th scope="col" class="py-3" style="min-width: 150px;">MM Order ID</th>
              <th scope="col" class="pe-4 py-3" style="min-width: 155px;">Success Time</th>
            </tr>
          }
          
        </thead>
        
        <!-- Table Functional Core Body Rows Loops -->
        <tbody class="small text-body">
          @for (data of transactionList() | paginate: { 
            itemsPerPage: pageSize(), 
            currentPage: page(), 
            totalItems: allTotal() 
          }; track $index) {
            
            <!-- Render Row Matrix 1: BOP Strategy -->
            @if (type.includes('BOP')) {
              <tr class="transition-base">
                <td class="ps-4 font-monospace fw-medium text-body-secondary">{{ data.srNo }}</td>
                <td class="fw-bold text-body font-monospace">{{ data.transactionId }}</td>
                <td class="font-monospace fw-semibold text-body">{{ data.paymentPhone }}</td>
                <td><span class="badge bg-body-secondary text-body-secondary border border-secondary-subtle px-2.5 py-1 shadow-sm font-monospace">{{ data.servicename }}</span></td>
                <td class="font-monospace text-body-secondary">{{ data.resultCode }}</td>
                <td class="text-truncate max-w-220 text-body-secondary" [title]="data.description">{{ data.description || '-' }}</td>
                
                <td class="pe-4 text-center">
                  <!-- Fixed multiple tracking classes conflicting layout bugs by using clean ngClass mappings -->
                  <span class="badge rounded-pill px-2.5 py-1.5 font-monospace tracking-wide font-xs fw-semibold"
                        [ngClass]="{
                          'bg-success-subtle text-success-emphasis border border-success-subtle': data.status?.toLowerCase() === 'success' || data.status?.toLowerCase() === 'completed',
                          'bg-warning-subtle text-warning-emphasis border border-warning-subtle': data.status?.toLowerCase() === 'processing' || data.status?.toLowerCase() === 'pending',
                          'bg-danger-subtle text-danger-emphasis border border-danger-subtle': data.status?.toLowerCase() === 'failed' || data.status?.toLowerCase() === 'error'
                        }">
                    {{ data.status || 'UNKNOWN' }}
                  </span>
                </td>
              </tr>
            }
            
            <!-- Render Row Matrix 2: BOW Strategy -->
            @if (type.includes('BOW')) {
              <tr class="transition-base">
                <td class="ps-4 font-monospace fw-medium text-body-secondary">{{ data.srNo }}</td>
                <td class="font-monospace fw-semibold text-body">{{ data.paymentPhone }}</td>
                <td class="fw-bold text-body">{{ data.paymentName }}</td>
                <td class="pe-4 text-body-secondary text-truncate max-w-300 font-xs" [title]="data.msg">{{ data.msg || '-' }}</td>
              </tr>
            }
            
            <!-- Render Row Matrix 3: KBZ Strategy -->
            @if (type.includes('KBZ')) {
              <tr class="transition-base">
                <td class="ps-4 font-monospace fw-medium text-body-secondary">{{ data.srNo }}</td>
                <td class="font-monospace fw-semibold text-body">{{ data.paymentPhone }}</td>
                <td class="fw-bold text-body">{{ data.paymentName }}</td>
                <td class="font-monospace text-body-secondary text-center">{{ data.errorStatusCode || '-' }}</td>
                <td class="fw-medium text-body">{{ data.result || '-' }}</td>
                <td class="font-monospace font-xs text-body-secondary">{{ data.code || '-' }}</td>
                
                <td class="text-center">
                  <span class="badge rounded-pill px-2.5 py-1.5 font-monospace font-xs fw-semibold"
                        [ngClass]="data.tradeStatus?.toLowerCase() === 'success' ? 'bg-success-subtle text-success-emphasis border border-success-subtle' : 'bg-danger-subtle text-danger-emphasis border border-danger-subtle'">
                    {{ data.tradeStatus || 'UNKNOWN' }}
                  </span>
                </td>
                
                <td class="text-body-secondary font-xs text-truncate max-w-200" [title]="data.msg">{{ data.msg || '-' }}</td>
                <td class="font-monospace text-end fw-bold text-success-emphasis pe-3">{{ data.totalAmount | number }}</td>
                <td class="font-monospace text-center text-body-secondary fw-semibold">{{ data.transCurrency || 'MMK' }}</td>
                <td class="font-monospace text-body-secondary font-xs">{{ data.mmOrderId }}</td>
                <td class="pe-4 text-body-secondary font-monospace font-xs">{{ data.paySuccessTime | dateFormat }}</td>
              </tr>
            }
            
          } @empty {
            <!-- Empty Data Grid Operational Fallback View Placeholder -->
            <tr>
              <td [attr.colspan]="type.includes('KBZ') ? 12 : (type.includes('BOP') ? 7 : 4)" class="text-center py-5 text-body-secondary font-monospace">
              <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                <span class="tracking-wider"> Transaction not foun!</span>
              </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Component Navigation Pagination Footer Area -->
  <div class="d-flex justify-content-center mt-3">
    <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
      class="dashboard-pagination" (pageChange)="handlePageChange($event)">
    </pagination-controls>
  </div>

</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}